import { ProductSlug } from "@/api/product-api";

// referral 할인 대상 제품(14개). referrer 개별 percentile(`bh_rcode` 쿠키)이 이 제품들에만
// 적용된다. docs/global-e-backend-contract.md §5.4.
//
// hook(`useReferralDiscount`)과 분리한 이유: 서버 API route(Global-E GetCheckoutCartInfo)도
// 이 순수 함수를 쓰는데, hook 파일을 import 하면 react/react-use/OrderService 그래프까지
// 서버 번들에 끌려온다. 순수 로직만 여기 두고 hook 은 이걸 re-export 한다.
export const REFERRAL_DISCOUNT_ITEMS: string[] = [
  ProductSlug.FPS_BUNDLE,
  ProductSlug.TACTSUIT_PRO,
  ProductSlug.TACTSUIT_AIR,
  ProductSlug.TACTSUIT_AIR_CAMO,
  ProductSlug.TACTSLEEVE,
  ProductSlug.TACTVISOR,
  ProductSlug.TACTGLOVE_DK2,
  ProductSlug.TACTGLOVE_DK2_BUNDLE,
  ProductSlug.TACTOSY_FOR_FEET,
  ProductSlug.STARTER_BUNDLE,
  ProductSlug.STARTER_BUNDLE_CAMO,
  ProductSlug.FPS_BUNDLE_TACTVISOR,
  ProductSlug.METRO_BUNDLE,
  ProductSlug.ARIZONA_BUNDLE,
];

export function isReferralActiveForProduct(slug: string): boolean {
  return REFERRAL_DISCOUNT_ITEMS.includes(slug);
}
